export const LAYOUT = {
  COLLECTION_PAGE: 'Collection Page',
  CROSS_PROMOTION: 'Cross Promotion',
};
